// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/gobot1-background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/send-plane-green.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/save-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/four-feedback-icons-dark.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  /* background-image: url("../img/gobot1-background.png"); */
    background-image: linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.2)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover; /* This ensures the background covers the entire area */
  background-repeat: no-repeat; /* This prevents the background from repeating */
  background-position: center center; /* This centers the background image */
  display: flex;
  flex-direction: column;
;
    justify-content: center;
    align-items: flex-start; /* keeps logo left-aligned */
    height: 100vh;
}

.logo-container {
  display: flex;
  padding: 0px 0px 0px 40px;
  justify-content: flex-start; /* Align items to the left */
  align-items: center; /* Optional: vertically center the image if needed */
}

.logo-container img {
  margin: 0;
  width: 200px;
}


.chat-container {
	width: 90%;
	margin: 0 40px 40px 40px;
	padding: 0;
	background-color: black; /* Clean white background */
	border: 1px solid #F0F0F0; /* Subtle light gray border */
	border-radius: 10px; /* Soft rounded edges */
	font-family: 'Inter', Arial, sans-serif; /* Global font */
	font-size: 16px; /* Base size */
	line-height: 1.5; /* Improved readability */
  opacity: 0.8;
}

.chat-box {
	height: 500px;
	overflow-y: auto;
  overflow-x: hidden;
	border: none;
	padding: 10px;
	margin-bottom: 10px;
	background-color: #F5F5F6; /* Light gray background, matching the toggle section style */
	display: flex;
	flex-direction: column;
	border-radius: 10px; /* Rounded corners */
}

.hidden {
	display: none; /* Hidden elements remain invisible initially */
	width: 0; /* Width set to 0 for hidden state */
	transition: width 0.5s; /* Smooth width transition */
}

.chat-message {
	width: 100%;
	margin-bottom: 10px;
	padding: 10px;
	border-radius: 10px; /* Rounded edges for consistency */
	background-color: black;
  opacity: 1 !important;
	/* color: #333333; Neutral dark gray text */
  color: white;
	font-size: 16px; /* Base size */
	font-weight: 400; /* Regular weight */
}

.all-windows-container {
/* Organize elements in a single row, left to right */
  display: flex;
  justify-content: space-between; /* Distribute space between elements */
  flex-direction: row
}

.left-menu {
  height: 624px;
  /* background-image: url('../img/left-menu-mockup.png'); */
  /* background-size: cover; This ensures the background covers the entire area */
  background-color: black;
  opacity: 0.85;
  border-radius: 10px;
  width: 400px;
  background-repeat: no-repeat; /* This prevents the background from repeating */
  margin: 0px 0px 0px 40px;
  /* padding: 20px 30px 0px 28px; */
  background-position: center center; /* This centers the background image */
}

.left-menu img {
  margin: 20px;
  width: 280px;
}

.bot-message {
	background-color: #F5F5F6; /* Light gray for bot messages */
	color: white; /* Dark gray for readability */
	font-size: 16px;
	font-weight: 400;
  opacity: 1;
  width: 90%;
}

.user-message {
	/* background-color: white; Keep it clean and minimal */
	color: white;
  opacity: 1;
	border: 4px solid #008000; /* Green border for user messages */
	border-radius: 10px; /* Consistent rounded corners */
	align-self: flex-end;
	width: auto;
  margin: 0px 20px 0px 0px;
	padding: 8px 12px;
	text-align: right;
	font-size: 16px; /* Standard text size */
	font-weight: 400; /* Regular weight */
}

.chat-input {
	display: flex;
	gap: 10px;
}

#user-input {
  padding: 3px;
}

.chat-input input {
	flex-grow: 1;
  height: 40px;
	padding: 10px;
	border-radius: 5px; /* Rounded corners */
	/* border: 1px solid #A0ABBB; Subtle light gray border */
  border: 1px solid green;
	background-color: black;
	outline-color: green; /* Light gray outline */
	outline-width: 4px;
  outline-style: solid;
	font-size: 16px; /* Match body text */
  margin: 20px 0px 20px 20px !important;
	font-weight: 400;
	/* color: #333333; Neutral dark gray text */
  background-color: transparent;
  color: white;
}

.error-message {
	color: red;
	font-size: 14px; /* Slightly smaller to denote emphasis */
	font-weight: 400;
}

.chat-input button#send-btn {
	width: 50px;
	height: 50px;
	border: none;
	cursor: pointer;
  margin: 20px 20px 0px 0px;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
	background-color:transparent;
  filter: saturate(0%);
	/* filter: brightness(100%); */
    /* transition: filter 0.3s ease; */
  position:relative;
}

.chat-input button#save-btn {
	width: 50px;
	height: 50px;
	border: none;
	cursor: pointer;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
	background-color:white;
	/* filter: brightness(100%); */
	filter: saturate(0%);
    transition: filter 0.3s ease;
  position:relative;
  display: none; /* this feature is not part of the gobot1 delivery */
}

.chat-input button#send-btn:hover,
.chat-input button#save-btn:hover {
	filter: brightness(120%); /* Subtle hover brightness */
}

.chat-input button#toggle-btn {
	width: 50px;
	height: 50px;
	border: none;
	cursor: pointer;
	background-color: white; 
	font-family: 'Inter', Arial, sans-serif;
	font-size: 18px; /* Consistent with other buttons */
	font-weight: bold;
	color: #008000;/* Green to match design */
	border-radius: 25px; /* Circular button */
	filter: brightness(100%);
	transition: filter 0.3s ease;
	display: none; /* Keep toggle hidden initially */
} 

.chat-input button#toggle-btn:hover {
	filter: brightness(120%);
}

.button-container {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

/* Header Styling */
header, .chat-container h1 {
	font-size: 24px; /* Large header font size */
	font-weight: 700; /* Bold for emphasis */
	color: #FFFFFF; /* White text */
	text-align: center; /* Center-align text */
	background-color: #008000; /* Green background */
	padding: 10px 0;
	border-radius: 10px 10px 0 0; /* Rounded top corners */
}

/* Subheaders or Section Titles */
.subheader, .chat-container h2 {
	font-size: 18px;
	font-weight: 600; /* Slightly bold */
	color: #333333; /* Neutral dark gray */
	margin: 10px 0;
}

/* Secondary Text */
.secondary-text {
	font-size: 14px; /* Slightly smaller than body text */
	font-weight: 400; /* Regular weight */
	color: #666666; /* Lighter gray for less emphasis */
}

/* Insert feedback icons after every bot message */
.bot-message::after {
  content: "";
  display: block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); /* Replace with the path to your image */
  width: 150px; /* Set the width of the image */
  height: 38px; /* Set the height of the image */
  background-size: contain; /* Adjust this as needed */
  background-repeat: no-repeat;
  margin-top: 10px; /* Add some spacing between the text and the image */
  /* Other styling if needed */
  cursor:pointer;
  filter: saturate(100%);
  transition: filter 0.3s;
  /* margin-left: 30px; */
}

.page-container, 
#error-container, 
#chatheader,
.chat-message,
.chat-box,
.message-content
/* .chat-outerwindow   done in the class, not in this override. */
{
  background-color: transparent;
}


/* For Webkit-based browsers (Chrome, Edge, Safari) */
.chat-box::-webkit-scrollbar {
  width: 8px; /* Width of the scrollbar */
}

.chat-box::-webkit-scrollbar-thumb {
  background-color: #008000; /* Scrollbar color (green) */
  border-radius: 10px; /* Rounded corners for the scrollbar */
}

.chat-box::-webkit-scrollbar-thumb:hover {
  background-color: black; /* Darker green on hover */
  opacity: 0.8;
}

.chat-box::-webkit-scrollbar-track {
  background-color: transparent; /* Scrollbar track background color */
  border-radius: 10px; /* Rounded corners for the track */
}

/* For Firefox */
.chat-box {
  scrollbar-width: thin; /* Makes the scrollbar thinner */
  scrollbar-color: #008000 transparent; /* Scrollbar thumb color and track color */
}`, "",{"version":3,"sources":["webpack://./css/gobot1.css"],"names":[],"mappings":"AAAA;EACE,2DAA2D;IACzD,8HAA0H;IAC1H,sBAAsB,EAAE,uDAAuD;EACjF,4BAA4B,EAAE,gDAAgD;EAC9E,kCAAkC,EAAE,sCAAsC;EAC1E,aAAa;EACb,sBAAsB;;IAEpB,uBAAuB;IACvB,uBAAuB,EAAE,4BAA4B;IACrD,aAAa;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,2BAA2B,EAAE,4BAA4B;EACzD,mBAAmB,EAAE,oDAAoD;AAC3E;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;;AAGA;CACC,UAAU;CACV,wBAAwB;CACxB,UAAU;CACV,uBAAuB,EAAE,2BAA2B;CACpD,yBAAyB,EAAE,6BAA6B;CACxD,mBAAmB,EAAE,uBAAuB;CAC5C,uCAAuC,EAAE,gBAAgB;CACzD,eAAe,EAAE,cAAc;CAC/B,gBAAgB,EAAE,yBAAyB;EAC1C,YAAY;AACd;;AAEA;CACC,aAAa;CACb,gBAAgB;EACf,kBAAkB;CACnB,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,yBAAyB,EAAE,6DAA6D;CACxF,aAAa;CACb,sBAAsB;CACtB,mBAAmB,EAAE,oBAAoB;AAC1C;;AAEA;CACC,aAAa,EAAE,+CAA+C;CAC9D,QAAQ,EAAE,oCAAoC;CAC9C,sBAAsB,EAAE,4BAA4B;AACrD;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,aAAa;CACb,mBAAmB,EAAE,kCAAkC;CACvD,uBAAuB;EACtB,qBAAqB;CACtB,2CAA2C;EAC1C,YAAY;CACb,eAAe,EAAE,cAAc;CAC/B,gBAAgB,EAAE,mBAAmB;AACtC;;AAEA;AACA,qDAAqD;EACnD,aAAa;EACb,8BAA8B,EAAE,sCAAsC;EACtE;AACF;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,+EAA+E;EAC/E,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,4BAA4B,EAAE,gDAAgD;EAC9E,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC,EAAE,sCAAsC;AAC5E;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;CACC,yBAAyB,EAAE,gCAAgC;CAC3D,YAAY,EAAE,8BAA8B;CAC5C,eAAe;CACf,gBAAgB;EACf,UAAU;EACV,UAAU;AACZ;;AAEA;CACC,uDAAuD;CACvD,YAAY;EACX,UAAU;CACX,yBAAyB,EAAE,mCAAmC;CAC9D,mBAAmB,EAAE,+BAA+B;CACpD,oBAAoB;CACpB,WAAW;EACV,wBAAwB;CACzB,iBAAiB;CACjB,iBAAiB;CACjB,eAAe,EAAE,uBAAuB;CACxC,gBAAgB,EAAE,mBAAmB;AACtC;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;CACC,YAAY;EACX,YAAY;CACb,aAAa;CACb,kBAAkB,EAAE,oBAAoB;CACxC,wDAAwD;EACvD,uBAAuB;CACxB,uBAAuB;CACvB,oBAAoB,EAAE,uBAAuB;CAC7C,kBAAkB;EACjB,oBAAoB;CACrB,eAAe,EAAE,oBAAoB;EACpC,qCAAqC;CACtC,gBAAgB;CAChB,2CAA2C;EAC1C,6BAA6B;EAC7B,YAAY;AACd;;AAEA;CACC,UAAU;CACV,eAAe,EAAE,wCAAwC;CACzD,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,eAAe;EACd,yBAAyB;CAC1B,yDAAoD;CACpD,4BAA4B;CAC5B,wBAAwB;CACxB,2BAA2B;CAC3B,4BAA4B;EAC3B,oBAAoB;CACrB,8BAA8B;IAC3B,kCAAkC;EACpC,iBAAiB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,yDAA6C;CAC7C,4BAA4B;CAC5B,wBAAwB;CACxB,2BAA2B;CAC3B,sBAAsB;CACtB,8BAA8B;CAC9B,oBAAoB;IACjB,4BAA4B;EAC9B,iBAAiB;EACjB,aAAa,EAAE,oDAAoD;AACrE;;AAEA;;CAEC,wBAAwB,EAAE,4BAA4B;AACvD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,uBAAuB;CACvB,uCAAuC;CACvC,eAAe,EAAE,kCAAkC;CACnD,iBAAiB;CACjB,cAAc,CAAC,0BAA0B;CACzC,mBAAmB,EAAE,oBAAoB;CACzC,wBAAwB;CACxB,4BAA4B;CAC5B,aAAa,EAAE,iCAAiC;AACjD;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA,mBAAmB;AACnB;CACC,eAAe,EAAE,2BAA2B;CAC5C,gBAAgB,EAAE,sBAAsB;CACxC,cAAc,EAAE,eAAe;CAC/B,kBAAkB,EAAE,sBAAsB;CAC1C,yBAAyB,EAAE,qBAAqB;CAChD,eAAe;CACf,4BAA4B,EAAE,wBAAwB;AACvD;;AAEA,iCAAiC;AACjC;CACC,eAAe;CACf,gBAAgB,EAAE,kBAAkB;CACpC,cAAc,EAAE,sBAAsB;CACtC,cAAc;AACf;;AAEA,mBAAmB;AACnB;CACC,eAAe,EAAE,oCAAoC;CACrD,gBAAgB,EAAE,mBAAmB;CACrC,cAAc,EAAE,mCAAmC;AACpD;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,cAAc;EACd,yDAA4D,EAAE,wCAAwC;EACtG,YAAY,EAAE,+BAA+B;EAC7C,YAAY,EAAE,gCAAgC;EAC9C,wBAAwB,EAAE,0BAA0B;EACpD,4BAA4B;EAC5B,gBAAgB,EAAE,oDAAoD;EACtE,4BAA4B;EAC5B,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;;AAGA,qDAAqD;AACrD;EACE,UAAU,EAAE,2BAA2B;AACzC;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;EACvD,mBAAmB,EAAE,sCAAsC;AAC7D;;AAEA;EACE,uBAAuB,EAAE,0BAA0B;EACnD,YAAY;AACd;;AAEA;EACE,6BAA6B,EAAE,qCAAqC;EACpE,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA,gBAAgB;AAChB;EACE,qBAAqB,EAAE,gCAAgC;EACvD,oCAAoC,EAAE,0CAA0C;AAClF","sourcesContent":["body {\r\n  /* background-image: url(\"../img/gobot1-background.png\"); */\r\n    background-image: linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.2)), url('../img/gobot1-background.png');\r\n    background-size: cover; /* This ensures the background covers the entire area */\r\n  background-repeat: no-repeat; /* This prevents the background from repeating */\r\n  background-position: center center; /* This centers the background image */\r\n  display: flex;\r\n  flex-direction: column;\r\n;\r\n    justify-content: center;\r\n    align-items: flex-start; /* keeps logo left-aligned */\r\n    height: 100vh;\r\n}\r\n\r\n.logo-container {\r\n  display: flex;\r\n  padding: 0px 0px 0px 40px;\r\n  justify-content: flex-start; /* Align items to the left */\r\n  align-items: center; /* Optional: vertically center the image if needed */\r\n}\r\n\r\n.logo-container img {\r\n  margin: 0;\r\n  width: 200px;\r\n}\r\n\r\n\r\n.chat-container {\r\n\twidth: 90%;\r\n\tmargin: 0 40px 40px 40px;\r\n\tpadding: 0;\r\n\tbackground-color: black; /* Clean white background */\r\n\tborder: 1px solid #F0F0F0; /* Subtle light gray border */\r\n\tborder-radius: 10px; /* Soft rounded edges */\r\n\tfont-family: 'Inter', Arial, sans-serif; /* Global font */\r\n\tfont-size: 16px; /* Base size */\r\n\tline-height: 1.5; /* Improved readability */\r\n  opacity: 0.8;\r\n}\r\n\r\n.chat-box {\r\n\theight: 500px;\r\n\toverflow-y: auto;\r\n  overflow-x: hidden;\r\n\tborder: none;\r\n\tpadding: 10px;\r\n\tmargin-bottom: 10px;\r\n\tbackground-color: #F5F5F6; /* Light gray background, matching the toggle section style */\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tborder-radius: 10px; /* Rounded corners */\r\n}\r\n\r\n.hidden {\r\n\tdisplay: none; /* Hidden elements remain invisible initially */\r\n\twidth: 0; /* Width set to 0 for hidden state */\r\n\ttransition: width 0.5s; /* Smooth width transition */\r\n}\r\n\r\n.chat-message {\r\n\twidth: 100%;\r\n\tmargin-bottom: 10px;\r\n\tpadding: 10px;\r\n\tborder-radius: 10px; /* Rounded edges for consistency */\r\n\tbackground-color: black;\r\n  opacity: 1 !important;\r\n\t/* color: #333333; Neutral dark gray text */\r\n  color: white;\r\n\tfont-size: 16px; /* Base size */\r\n\tfont-weight: 400; /* Regular weight */\r\n}\r\n\r\n.all-windows-container {\r\n/* Organize elements in a single row, left to right */\r\n  display: flex;\r\n  justify-content: space-between; /* Distribute space between elements */\r\n  flex-direction: row\r\n}\r\n\r\n.left-menu {\r\n  height: 624px;\r\n  /* background-image: url('../img/left-menu-mockup.png'); */\r\n  /* background-size: cover; This ensures the background covers the entire area */\r\n  background-color: black;\r\n  opacity: 0.85;\r\n  border-radius: 10px;\r\n  width: 400px;\r\n  background-repeat: no-repeat; /* This prevents the background from repeating */\r\n  margin: 0px 0px 0px 40px;\r\n  /* padding: 20px 30px 0px 28px; */\r\n  background-position: center center; /* This centers the background image */\r\n}\r\n\r\n.left-menu img {\r\n  margin: 20px;\r\n  width: 280px;\r\n}\r\n\r\n.bot-message {\r\n\tbackground-color: #F5F5F6; /* Light gray for bot messages */\r\n\tcolor: white; /* Dark gray for readability */\r\n\tfont-size: 16px;\r\n\tfont-weight: 400;\r\n  opacity: 1;\r\n  width: 90%;\r\n}\r\n\r\n.user-message {\r\n\t/* background-color: white; Keep it clean and minimal */\r\n\tcolor: white;\r\n  opacity: 1;\r\n\tborder: 4px solid #008000; /* Green border for user messages */\r\n\tborder-radius: 10px; /* Consistent rounded corners */\r\n\talign-self: flex-end;\r\n\twidth: auto;\r\n  margin: 0px 20px 0px 0px;\r\n\tpadding: 8px 12px;\r\n\ttext-align: right;\r\n\tfont-size: 16px; /* Standard text size */\r\n\tfont-weight: 400; /* Regular weight */\r\n}\r\n\r\n.chat-input {\r\n\tdisplay: flex;\r\n\tgap: 10px;\r\n}\r\n\r\n#user-input {\r\n  padding: 3px;\r\n}\r\n\r\n.chat-input input {\r\n\tflex-grow: 1;\r\n  height: 40px;\r\n\tpadding: 10px;\r\n\tborder-radius: 5px; /* Rounded corners */\r\n\t/* border: 1px solid #A0ABBB; Subtle light gray border */\r\n  border: 1px solid green;\r\n\tbackground-color: black;\r\n\toutline-color: green; /* Light gray outline */\r\n\toutline-width: 4px;\r\n  outline-style: solid;\r\n\tfont-size: 16px; /* Match body text */\r\n  margin: 20px 0px 20px 20px !important;\r\n\tfont-weight: 400;\r\n\t/* color: #333333; Neutral dark gray text */\r\n  background-color: transparent;\r\n  color: white;\r\n}\r\n\r\n.error-message {\r\n\tcolor: red;\r\n\tfont-size: 14px; /* Slightly smaller to denote emphasis */\r\n\tfont-weight: 400;\r\n}\r\n\r\n.chat-input button#send-btn {\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\tborder: none;\r\n\tcursor: pointer;\r\n  margin: 20px 20px 0px 0px;\r\n\tbackground-image: url(\"../img/send-plane-green.png\");\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-size: contain;\r\n\tbackground-position: center;\r\n\tbackground-color:transparent;\r\n  filter: saturate(0%);\r\n\t/* filter: brightness(100%); */\r\n    /* transition: filter 0.3s ease; */\r\n  position:relative;\r\n}\r\n\r\n.chat-input button#save-btn {\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\tborder: none;\r\n\tcursor: pointer;\r\n\tbackground-image: url(\"../img/save-icon.png\");\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-size: contain;\r\n\tbackground-position: center;\r\n\tbackground-color:white;\r\n\t/* filter: brightness(100%); */\r\n\tfilter: saturate(0%);\r\n    transition: filter 0.3s ease;\r\n  position:relative;\r\n  display: none; /* this feature is not part of the gobot1 delivery */\r\n}\r\n\r\n.chat-input button#send-btn:hover,\r\n.chat-input button#save-btn:hover {\r\n\tfilter: brightness(120%); /* Subtle hover brightness */\r\n}\r\n\r\n.chat-input button#toggle-btn {\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\tborder: none;\r\n\tcursor: pointer;\r\n\tbackground-color: white; \r\n\tfont-family: 'Inter', Arial, sans-serif;\r\n\tfont-size: 18px; /* Consistent with other buttons */\r\n\tfont-weight: bold;\r\n\tcolor: #008000;/* Green to match design */\r\n\tborder-radius: 25px; /* Circular button */\r\n\tfilter: brightness(100%);\r\n\ttransition: filter 0.3s ease;\r\n\tdisplay: none; /* Keep toggle hidden initially */\r\n} \r\n\r\n.chat-input button#toggle-btn:hover {\r\n\tfilter: brightness(120%);\r\n}\r\n\r\n.button-container {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 10px;\r\n}\r\n\r\n/* Header Styling */\r\nheader, .chat-container h1 {\r\n\tfont-size: 24px; /* Large header font size */\r\n\tfont-weight: 700; /* Bold for emphasis */\r\n\tcolor: #FFFFFF; /* White text */\r\n\ttext-align: center; /* Center-align text */\r\n\tbackground-color: #008000; /* Green background */\r\n\tpadding: 10px 0;\r\n\tborder-radius: 10px 10px 0 0; /* Rounded top corners */\r\n}\r\n\r\n/* Subheaders or Section Titles */\r\n.subheader, .chat-container h2 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 600; /* Slightly bold */\r\n\tcolor: #333333; /* Neutral dark gray */\r\n\tmargin: 10px 0;\r\n}\r\n\r\n/* Secondary Text */\r\n.secondary-text {\r\n\tfont-size: 14px; /* Slightly smaller than body text */\r\n\tfont-weight: 400; /* Regular weight */\r\n\tcolor: #666666; /* Lighter gray for less emphasis */\r\n}\r\n\r\n/* Insert feedback icons after every bot message */\r\n.bot-message::after {\r\n  content: \"\";\r\n  display: block;\r\n  background-image: url(\"../img/four-feedback-icons-dark.png\"); /* Replace with the path to your image */\r\n  width: 150px; /* Set the width of the image */\r\n  height: 38px; /* Set the height of the image */\r\n  background-size: contain; /* Adjust this as needed */\r\n  background-repeat: no-repeat;\r\n  margin-top: 10px; /* Add some spacing between the text and the image */\r\n  /* Other styling if needed */\r\n  cursor:pointer;\r\n  filter: saturate(100%);\r\n  transition: filter 0.3s;\r\n  /* margin-left: 30px; */\r\n}\r\n\r\n.page-container, \r\n#error-container, \r\n#chatheader,\r\n.chat-message,\r\n.chat-box,\r\n.message-content\r\n/* .chat-outerwindow   done in the class, not in this override. */\r\n{\r\n  background-color: transparent;\r\n}\r\n\r\n\r\n/* For Webkit-based browsers (Chrome, Edge, Safari) */\r\n.chat-box::-webkit-scrollbar {\r\n  width: 8px; /* Width of the scrollbar */\r\n}\r\n\r\n.chat-box::-webkit-scrollbar-thumb {\r\n  background-color: #008000; /* Scrollbar color (green) */\r\n  border-radius: 10px; /* Rounded corners for the scrollbar */\r\n}\r\n\r\n.chat-box::-webkit-scrollbar-thumb:hover {\r\n  background-color: black; /* Darker green on hover */\r\n  opacity: 0.8;\r\n}\r\n\r\n.chat-box::-webkit-scrollbar-track {\r\n  background-color: transparent; /* Scrollbar track background color */\r\n  border-radius: 10px; /* Rounded corners for the track */\r\n}\r\n\r\n/* For Firefox */\r\n.chat-box {\r\n  scrollbar-width: thin; /* Makes the scrollbar thinner */\r\n  scrollbar-color: #008000 transparent; /* Scrollbar thumb color and track color */\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
